<template>
  <div class="sechch-bg">
    <div class="container">
      <div class="logo">
        <img :src="logoURL" alt="" />
      </div>
      <div class="input-box">
        <input
          v-model="sreachDataPc"
          type="text"
          class="input-len"
          placeholder="输入你想查找的药品"
        />
        <div class="btn" @click="sreach">
          搜索
        </div>
      </div>
      <div class="hot-list">
        <span>热门搜索：</span>
        <span
          v-for="(item, index) in promotionTags"
          :key="index"
          @click="selectTags(index)"
          >{{ item }}</span
        >
      </div>
      <div class="serve-time">
        <span>+00853 65885387</span>
      </div>
    </div>
  </div>
</template>

<script>
import { getSearchKeyword } from "@api/public";
import { getIndex } from "@api/public";
export default {
  name: "Search",
  props: {
    sreachData: {
      type: String,
      required: false,
      default: ""
    }
  },
  data() {
    return {
      sreachDataPc: this.sreachData,
      promotionTags: [],
      logoURL: ""
    };
  },
  created() {
    getSearchKeyword().then(res => {
      this.promotionTags = res.data;
    });
    getIndex().then(res => {
      this.logoURL = res.data.logoUrl;
    });
  },
  methods: {
    closeTags(index) {
      this.promotionTags.splice(index, 1);
    },
    selectTags(index) {
      let sreachDataPc = this.promotionTags[index];
      this.$router.push({
        path: "/goodsList",
        query: { sreachData: sreachDataPc }
      });
    },
    sreach() {
      this.$router.push({
        path: "/goodsList",
        query: { sreachData: this.sreachDataPc }
      });
    }
  }
};
</script>

<style lang="stylus" scoped>
.sechch-bg
  background #fff
  .container
    padding 30px 0
    margin 0px auto
    width 600px
    position relative
    .logo
      position absolute
      width 230px
      height 100px
      left -312px
      top 23px
      img
        width 100%
        height 100%
    .input-box
      border 2px solid #1880f4
      display flex
      height 40px
      line-height 40px
      .input-len
        flex 1
        font-size 14px
        margin-left 14px
        font-family '宋体'
      .btn
        cursor pointer
        width 100px
        background #1880f4
        color #fff
        text-align center
        font-size 18px
        letter-spacing 4px
    .hot-list
      margin-top 5px
      font-size 13px
      color #acacac
      span
        margin-right 15px
        cursor pointer
        &:first-child
          color #666
    .serve-time
      position absolute
      // right -300px
      // top 30px
      right -281px
      top 122px
      width 162px
      height 37px
      background url('../../assets/pc/images/nav/serve-time.jpg') no-repeat center center / 100% 100%
      span
        position absolute
        left 24px
        top 18px
        font-size 16px
        font-family 'Arial'
        font-weight 700
        color #2f88dc

::-webkit-input-placeholder
  color #333
  font-weight: 700
  font-size 16px
::-moz-placeholder
  color #333
  font-weight: 700
  font-size 16px
:-moz-placeholder
  color #333
  font-weight: 700
  font-size 16px
:-ms-input-placeholder
  color #333
  font-weight: 700
  font-size 16px
</style>
